// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","body":"_2lYHSCAcM6vA2s-47YYZeS","primaryGreen":"#028154","customWhite":"#ffffff","customGrey":"#4b4b4b","borderGrey":"#d5dfdf","customGreyFaded":"#f7f9fc","mobileThreshold":"575px","container":"_1J9pt8WrjRvbCXWMWOF79H _2lYHSCAcM6vA2s-47YYZeS","selected":"mQ2tYDGVsRXGCGw_emdu","marker":"_6WmRc5W3JFWf5ddksCbYM"};


//////////////////
// WEBPACK FOOTER
// ./src/common/radio-bullet/RadioBullet.css
// module id = 705
// module chunks = 0